import { isStudioModuleEntitled } from "./studioModules";

export const isOrdersEnabled = (): boolean =>
  process.env.REACT_APP_ORDERS_ENABLED === "true" ||
  process.env.REACT_APP_ENV === "loc";

export const canUseOrders = (role?: string): boolean => {
  if (!isOrdersEnabled() || !role) {
    return false;
  }
  const allowed =
    role === "SUPER_ADMIN" ||
    role === "ORGANIZATION_ADMIN" ||
    role === "ORGANIZATION_MANAGER";
  if (!allowed) {
    return false;
  }
  if (role === "SUPER_ADMIN") {
    return true;
  }
  return isStudioModuleEntitled("ORDERS");
};
